import { render, staticRenderFns } from "./ProductInfoChange.vue?vue&type=template&id=5adcdbf1&scoped=true&"
import script from "./ProductInfoChange.vue?vue&type=script&lang=js&"
export * from "./ProductInfoChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adcdbf1",
  null
  
)

export default component.exports